var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconViewAll(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.651,
    height: 6.39,
    viewBox: "0 0 3.651 6.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11320",
    "data-name": "Path 11320",
    d: "M60.809,237.549H55.217a.381.381,0,0,0-.281.12.4.4,0,0,0,0,.57l2.8,2.84a.388.388,0,0,0,.562,0l2.8-2.84a.4.4,0,0,0,0-.571A.381.381,0,0,0,60.809,237.549Z",
    transform: "translate(-237.549 61.208) rotate(-90)",
    fill: "#1e2439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewAll);
export default __webpack_public_path__ + "static/media/IconViewAll.869fd73bdb06b88c5f58cdd6d72abe21.svg";
export { ForwardRef as ReactComponent };